<modal
  [id]="id()"
  [header]="header()"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [widthClass]="widthClass()"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="true"
  (onCloseModal)="onModalClose()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-8 tw-font-inter">
    @if (isAddMode()) {
    <div class="tw-flex tw-flex-col tw-gap-4 tw-items-start tw-w-full tw-text-left">
      <div class="tw-font-normal tw-text-sm sm:tw-text-base tw-leading-[1.5] tw-text-gray-700">
        @if (summaryState() === 'add-empty') {
        <p class="tw-m-0 tw-leading-[1.5]">No entries were added. Every targeted entry was skipped.</p>
        <p class="tw-m-0 tw-leading-[1.5]">Review the reasons below.</p>
        } @else {
        <p class="tw-m-0 tw-leading-[1.5]">Your request has started successfully.</p>
        <p class="tw-m-0 tw-leading-[1.5]">
          <span class="tw-font-semibold">{{ countLabel() }}</span>
          {{ entriesWord() }} being added to the target persona collection. This may take some time to finish, but you can safely leave this screen.
        </p>
        }
      </div>
      @if (skipRows().length) {
      <ul class="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-3 tw-w-full">
        @for (row of skipRows(); track row.label) {
        <li class="tw-flex tw-items-center tw-gap-2">
          <img src="assets/images/v2/invite/skip-x.svg" alt="" class="tw-w-2.5 tw-h-2.5 sm:tw-w-3 sm:tw-h-3 tw-shrink-0 tw-mt-0.5" width="12" height="12" />
          <span class="tw-font-medium tw-text-xs sm:tw-text-sm tw-leading-[1.5] tw-text-gray-700">{{ row.count.toLocaleString() }} - {{ row.label }}</span>
        </li>
        }
      </ul>
      }
    </div>
    } @else {
    <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full tw-text-base tw-font-normal tw-leading-normal tw-text-gray-700">
      <div class="tw-m-0 tw-w-full">
        @switch (summaryState()) {
          @case ('before-send-blocked') {
            <p class="tw-m-0 tw-font-inter tw-leading-normal tw-text-gray-700 tw-text-base">
              None of the selected entries can receive an invitation right now.
            </p>
            <p class="tw-m-0 tw-font-inter tw-leading-normal tw-text-gray-700 tw-text-base">
              Review the reasons below, update your selection, and try again.
            </p>
          }
          @case ('after-send-empty') {
            <p class="tw-m-0 tw-font-inter tw-leading-normal tw-text-gray-700 tw-text-base">
              No invitations were queued. Every targeted entry was skipped.
            </p>
            <p class="tw-m-0 tw-font-inter tw-leading-normal tw-text-gray-700 tw-text-base">Review the reasons below.</p>
          }
          @default {
            <p class="tw-m-0 tw-font-inter tw-leading-normal tw-text-gray-700 tw-text-base">Your request has started successfully.</p>
            <p class="tw-m-0 tw-font-inter tw-leading-normal tw-text-gray-700 tw-text-base">
              <strong class="tw-font-semibold tw-font-inter tw-leading-normal tw-text-gray-700 tw-text-base">{{ countLabel() }}</strong>
              {{ entriesWord() }} being invited to your event. This may take some time to finish, but you can safely leave this
              screen.
            </p>
          }
        }
      </div>

      @if (skipRows().length > 0) {
        <div class="tw-flex tw-flex-col tw-gap-3 tw-w-full">
          @for (row of skipRows(); track row.label; let i = $index) {
            <div class="tw-flex tw-items-center tw-gap-2 tw-w-full">
              <div class="tw-flex tw-items-center tw-justify-center tw-p-0.5 tw-shrink-0">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="tw-block tw-shrink-0">
                  <g [attr.clip-path]="'url(#bulk_send_summary_skip_x_clip_' + i + ')'">
                    <path
                      d="M8.41152 7L13.6952 1.71628C13.7906 1.62419 13.8666 1.51404 13.919 1.39225C13.9713 1.27046 13.9988 1.13947 14 1.00692C14.0011 0.874375 13.9759 0.742926 13.9257 0.620245C13.8755 0.497564 13.8013 0.386108 13.7076 0.29238C13.6139 0.198652 13.5024 0.124529 13.3798 0.0743358C13.2571 0.0241431 13.1256 -0.0011141 12.9931 3.76909e-05C12.8605 0.00118949 12.7295 0.0287274 12.6078 0.0810446C12.486 0.133362 12.3758 0.209411 12.2837 0.304753L7 5.58848L1.71628 0.304753C1.528 0.122915 1.27584 0.0222964 1.01411 0.0245708C0.752369 0.0268452 0.501997 0.13183 0.316913 0.316913C0.13183 0.501997 0.0268452 0.752369 0.0245708 1.01411C0.0222964 1.27584 0.122915 1.528 0.304753 1.71628L5.58848 7L0.304753 12.2837C0.209411 12.3758 0.133362 12.486 0.0810446 12.6078C0.0287274 12.7295 0.00118949 12.8605 3.76909e-05 12.9931C-0.0011141 13.1256 0.0241431 13.2571 0.0743358 13.3798C0.124529 13.5024 0.198652 13.6139 0.29238 13.7076C0.386108 13.8013 0.497564 13.8755 0.620245 13.9257C0.742926 13.9759 0.874375 14.0011 1.00692 14C1.13947 13.9988 1.27046 13.9713 1.39225 13.919C1.51404 13.8666 1.62419 13.7906 1.71628 13.6952L7 8.41152L12.2837 13.6952C12.472 13.8771 12.7242 13.9777 12.9859 13.9754C13.2476 13.9732 13.498 13.8682 13.6831 13.6831C13.8682 13.498 13.9732 13.2476 13.9754 12.9859C13.9777 12.7242 13.8771 12.472 13.6952 12.2837L8.41152 7Z"
                      fill="#E02424"
                    />
                  </g>
                  <defs>
                    <clipPath [attr.id]="'bulk_send_summary_skip_x_clip_' + i">
                      <rect width="14" height="14" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p class="tw-m-0 tw-text-base tw-font-normal tw-leading-normal tw-text-gray-700 tw-font-inter">
                <strong class="tw-font-semibold">{{ row.count.toLocaleString() }}</strong> - {{ row.label }}
              </p>
            </div>
          }
        </div>
      }
    </div>
    }

    <div class="tw-flex tw-w-full tw-justify-end">
      <button
        type="button"
        class="tw-flex tw-h-[41px] lg:tw-h-auto tw-w-full lg:tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border-0 tw-bg-blue-600 tw-px-5 tw-py-2.5 tw-text-sm tw-font-medium tw-leading-normal tw-text-white tw-font-inter tw-cursor-pointer"
        (click)="onDone()"
      >
        Done
      </button>
    </div>
  </div>
</modal>
